export default __webpack_public_path__ + "static/media/reassigned.1c551069.svg";